import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center" };
const _hoisted_2 = {
    class: "relative w-full mx-4 bg-white shadow-xl rounded-2xl",
    style: { "max-width": "480px" }
};
const _hoisted_3 = { class: "flex items-center justify-between h-16 px-6 border-b border-gray-100" };
const _hoisted_4 = { class: "text-base font-bold text-gray-900" };
const _hoisted_5 = { class: "flex flex-col gap-4 px-6 pt-5 pb-4" };
const _hoisted_6 = { class: "text-[15px] font-bold text-gray-900" };
const _hoisted_7 = { class: "text-[13px] text-gray-400 mt-0.5" };
const _hoisted_8 = { class: "flex flex-col gap-3" };
const _hoisted_9 = {
    class: "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full",
    style: { "background-color": "#fef3f0" }
};
const _hoisted_10 = { class: "flex-1 min-w-0" };
const _hoisted_11 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_12 = { class: "text-xs text-gray-400 mt-0.5" };
const _hoisted_13 = {
    key: 0,
    class: "w-2 h-2 rounded-full",
    style: { "background-color": "#e8472a" }
};
const _hoisted_14 = {
    class: "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full",
    style: { "background-color": "#eef2ff" }
};
const _hoisted_15 = { class: "flex-1 min-w-0" };
const _hoisted_16 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_17 = { class: "text-xs text-gray-400 mt-0.5" };
const _hoisted_18 = {
    key: 0,
    class: "w-2 h-2 rounded-full",
    style: { "background-color": "#e8472a" }
};
const _hoisted_19 = { class: "flex items-center justify-end gap-3 px-6 pb-6" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = { class: "flex items-center h-16 gap-3 px-6 border-b border-gray-100" };
const _hoisted_22 = { class: "flex-1 text-base font-bold text-gray-900" };
const _hoisted_23 = { class: "flex flex-col gap-5 px-6 pt-5 pb-4" };
const _hoisted_24 = {
    key: 0,
    class: "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium self-start",
    style: { "background-color": "#fef3f0", "color": "#e8472a" }
};
const _hoisted_25 = {
    key: 1,
    class: "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium self-start",
    style: { "background-color": "#eef2ff", "color": "#6366f1" }
};
const _hoisted_26 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_27 = {
    value: "",
    disabled: ""
};
const _hoisted_28 = ["value"];
const _hoisted_29 = { class: "text-xs text-gray-400" };
const _hoisted_30 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_31 = {
    value: "",
    disabled: ""
};
const _hoisted_32 = ["value"];
const _hoisted_33 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = {
    value: "",
    disabled: ""
};
const _hoisted_36 = ["value"];
const _hoisted_37 = {
    key: 0,
    class: "mt-1 text-xs text-amber-600"
};
const _hoisted_38 = { class: "text-xs text-gray-400" };
const _hoisted_39 = { class: "flex items-center justify-end gap-3 px-6 pb-6" };
const _hoisted_40 = ["disabled"];
const _hoisted_41 = {
    key: 0,
    class: "w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"
};
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { IconX, IconSearch, IconMessage2, IconArrowRight, IconArrowLeft, IconPlus, } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewConversationModal',
    props: {
        providers: {},
        services: {},
        itineraries: {},
        mode: {},
        isCreating: { type: Boolean }
    },
    emits: ["create", "cancel"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const step = ref(props.mode === "provider" ? 2 : 1);
        const selectedType = ref(props.mode === "provider" ? "POST_BOOKING" : null);
        const preForm = ref({ serviceId: "" });
        const postForm = ref({ itineraryId: "", slotId: "" });
        const canUsePreBooking = computed(() => props.mode !== "provider");
        const canUsePostBooking = computed(() => true);
        const singleTypeMode = computed(() => !canUsePreBooking.value);
        watch(() => props.mode, (mode) => {
            if (mode === "provider") {
                selectedType.value = "POST_BOOKING";
                step.value = 2;
                return;
            }
            if (selectedType.value === "POST_BOOKING")
                return;
            selectedType.value = null;
            step.value = 1;
        });
        const selectedItinerarySlots = computed(() => {
            const it = (props.itineraries ?? []).find((i) => i.id === postForm.value.itineraryId);
            return it?.slots ?? [];
        });
        const selectedPostBookingSlot = computed(() => selectedItinerarySlots.value.find((s) => s.id === postForm.value.slotId));
        const canCreate = computed(() => {
            if (selectedType.value === "PRE_BOOKING")
                return !!preForm.value.serviceId;
            if (selectedType.value === "POST_BOOKING") {
                const slot = selectedPostBookingSlot.value;
                return !!(postForm.value.itineraryId &&
                    slot?.booking_id &&
                    slot?.service_id);
            }
            return false;
        });
        function handleCreate() {
            if (!selectedType.value || !canCreate.value)
                return;
            if (selectedType.value === "PRE_BOOKING") {
                emit("create", {
                    conversation_type: "PRE_BOOKING",
                    serviceId: preForm.value.serviceId,
                });
            }
            else {
                const slot = selectedPostBookingSlot.value;
                if (!slot)
                    return;
                emit("create", {
                    conversation_type: "POST_BOOKING",
                    itineraryId: postForm.value.itineraryId,
                    bookingId: slot.booking_id,
                    slotId: slot.slot_id || undefined,
                    serviceId: slot.service_id ?? "",
                    providerId: slot.provider_id || undefined,
                });
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        (step.value === 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("conversation.new_modal.title")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel'))),
                                        class: "p-1 text-gray-400 rounded-lg hover:bg-gray-100"
                                    }, [
                                        _createVNode(_unref(IconX), { class: "w-5 h-5" })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("conversation.new_modal.prompt_title")), 1),
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("conversation.new_modal.prompt_body")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        (canUsePreBooking.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[2] || (_cache[2] = ($event) => (selectedType.value = 'PRE_BOOKING')),
                                                class: "flex items-center w-full gap-4 p-4 text-left transition-colors border-2 rounded-xl",
                                                style: _normalizeStyle(selectedType.value === 'PRE_BOOKING'
                                                    ? 'border-color: #E8472A; background-color: #FFF5F3;'
                                                    : 'border-color: #E5E7EB; background-color: #FFFFFF;')
                                            }, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createVNode(_unref(IconSearch), {
                                                        class: "w-5 h-5",
                                                        style: { "color": "#e8472a" }
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("conversation.new_modal.pre_booking_title")), 1),
                                                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("conversation.new_modal.pre_booking_body")), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "flex items-center justify-center flex-shrink-0 w-4 h-4 border-2 rounded-full",
                                                    style: _normalizeStyle(selectedType.value === 'PRE_BOOKING'
                                                        ? 'border-color: #E8472A;'
                                                        : 'border-color: #D1D5DB;')
                                                }, [
                                                    (selectedType.value === 'PRE_BOOKING')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                                                        : _createCommentVNode("", true)
                                                ], 4)
                                            ], 4))
                                            : _createCommentVNode("", true),
                                        (canUsePostBooking.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                onClick: _cache[3] || (_cache[3] = ($event) => (selectedType.value = 'POST_BOOKING')),
                                                class: "flex items-center w-full gap-4 p-4 text-left transition-colors border-2 rounded-xl",
                                                style: _normalizeStyle(selectedType.value === 'POST_BOOKING'
                                                    ? 'border-color: #E8472A; background-color: #FFF5F3;'
                                                    : 'border-color: #E5E7EB; background-color: #FFFFFF;')
                                            }, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createVNode(_unref(IconMessage2), { class: "w-5 h-5 text-indigo-500" })
                                                ]),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("conversation.new_modal.post_booking_title")), 1),
                                                    _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)("conversation.new_modal.post_booking_body")), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "flex items-center justify-center flex-shrink-0 w-4 h-4 border-2 rounded-full",
                                                    style: _normalizeStyle(selectedType.value === 'POST_BOOKING'
                                                        ? 'border-color: #E8472A;'
                                                        : 'border-color: #D1D5DB;')
                                                }, [
                                                    (selectedType.value === 'POST_BOOKING')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                                                        : _createCommentVNode("", true)
                                                ], 4)
                                            ], 4))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('cancel'))),
                                        class: "px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50"
                                    }, _toDisplayString(_unref(t)("common.actions.cancel")), 1),
                                    _createElementVNode("button", {
                                        disabled: !selectedType.value,
                                        onClick: _cache[5] || (_cache[5] = ($event) => (step.value = 2)),
                                        class: "flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white rounded-xl disabled:opacity-40 disabled:cursor-not-allowed",
                                        style: { "background-color": "#e8472a" }
                                    }, [
                                        _createTextVNode(_toDisplayString(_unref(t)("conversation.new_modal.continue")) + " ", 1),
                                        _createVNode(_unref(IconArrowRight), { class: "w-4 h-4" })
                                    ], 8, _hoisted_20)
                                ])
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_21, [
                                    (!singleTypeMode.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: _cache[6] || (_cache[6] = ($event) => (step.value = 1)),
                                            class: "p-1 text-gray-400 rounded-lg hover:bg-gray-100"
                                        }, [
                                            _createVNode(_unref(IconArrowLeft), { class: "w-5 h-5" })
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("h2", _hoisted_22, _toDisplayString(_unref(t)("conversation.new_modal.title")), 1),
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center gap-1.5 mr-2" }, [
                                        _createElementVNode("span", {
                                            class: "w-2 h-2 rounded-full",
                                            style: { "background-color": "#e8472a" }
                                        }),
                                        _createElementVNode("span", {
                                            class: "w-2 h-2 rounded-full",
                                            style: { "background-color": "#e8472a" }
                                        })
                                    ], -1)),
                                    _createElementVNode("button", {
                                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$emit('cancel'))),
                                        class: "p-1 text-gray-400 rounded-lg hover:bg-gray-100"
                                    }, [
                                        _createVNode(_unref(IconX), { class: "w-5 h-5" })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    (selectedType.value === 'PRE_BOOKING')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_unref(t)("conversation.new_modal.pre_booking_chip")), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(t)("conversation.new_modal.post_booking_chip")), 1)),
                                    (selectedType.value === 'PRE_BOOKING')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(t)("conversation.filters.service")), 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((preForm.value.serviceId) = $event)),
                                                    class: "w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-eorange-400",
                                                    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb" }
                                                }, [
                                                    _createElementVNode("option", _hoisted_27, _toDisplayString(_unref(t)("conversation.new_modal.select_service")), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (s) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: s.id,
                                                            value: s.id
                                                        }, _toDisplayString(s.name), 9, _hoisted_28));
                                                    }), 128))
                                                ], 512), [
                                                    [_vModelSelect, preForm.value.serviceId]
                                                ])
                                            ]),
                                            _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)("conversation.new_modal.service_hint")), 1)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(t)("conversation.filters.itinerary")), 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((postForm.value.itineraryId) = $event)),
                                                    class: "w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-eorange-400",
                                                    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb" },
                                                    onChange: _cache[10] || (_cache[10] = ($event) => (postForm.value.slotId = ''))
                                                }, [
                                                    _createElementVNode("option", _hoisted_31, _toDisplayString(_unref(t)("conversation.new_modal.select_itinerary")), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itineraries, (it) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: it.id,
                                                            value: it.id
                                                        }, _toDisplayString(it.code), 9, _hoisted_32));
                                                    }), 128))
                                                ], 544), [
                                                    [_vModelSelect, postForm.value.itineraryId]
                                                ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)("conversation.new_modal.booked_service")), 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((postForm.value.slotId) = $event)),
                                                    class: "w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-eorange-400",
                                                    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb" },
                                                    disabled: !postForm.value.itineraryId
                                                }, [
                                                    _createElementVNode("option", _hoisted_35, _toDisplayString(_unref(t)("conversation.new_modal.select_booked_service")), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItinerarySlots.value, (slot) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: slot.id,
                                                            value: slot.id
                                                        }, _toDisplayString(slot.service_name ?? slot.id), 9, _hoisted_36));
                                                    }), 128))
                                                ], 8, _hoisted_34), [
                                                    [_vModelSelect, postForm.value.slotId]
                                                ]),
                                                (postForm.value.itineraryId && selectedItinerarySlots.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_unref(t)("conversation.new_modal.no_active_services")), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("p", _hoisted_38, _toDisplayString(_unref(t)("conversation.new_modal.itinerary_hint")), 1)
                                        ], 64))
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("button", {
                                        onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.$emit('cancel'))),
                                        class: "px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50"
                                    }, _toDisplayString(_unref(t)("common.actions.cancel")), 1),
                                    _createElementVNode("button", {
                                        disabled: !canCreate.value || __props.isCreating,
                                        onClick: handleCreate,
                                        class: "flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white rounded-xl disabled:opacity-40 disabled:cursor-not-allowed",
                                        style: { "background-color": "#e8472a" }
                                    }, [
                                        (__props.isCreating)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_41))
                                            : (_openBlock(), _createBlock(_unref(IconPlus), {
                                                key: 1,
                                                class: "w-4 h-4"
                                            })),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)("conversation.new_modal.create")), 1)
                                    ], 8, _hoisted_40)
                                ])
                            ], 64))
                    ])
                ])
            ]));
        };
    }
});
